import {Accordion as MuiAccordion, styled} from "@mui/material"
import Typography from "@mui/material/Typography"
import React, {useCallback, useContext, useState} from "react"
import {DataContext} from "../../../src/context/DataContextProvider"
import {getMerkmal} from "../../misc/widget-functions"
import {checkVisibility} from "../../misc/precondition-evaluation"
import Content from "../../components/Content"
import AccordionBase from "./accordion/AccordionBase"

export const containerAccordionPrototype = [
    {
        "key": "initialyOpen",
        "type": "CHECKBOX",
        "label": "Accordion initial geöffnet?",
        "size": 6,
    },
    {
        "key": "variant",
        "type": "SELECT",
        "label": "Varainte",
        "size": 6,
        "options": [
            {
                "value": "OUTLINED",
                "label": "Outlined",
            },
            {
                "value": "DEFAULT",
                "label": "Default",
            },
        ],
    },
    {
        "key": "icon",
        "type": "SELECT",
        "label": "icon left",
        "size": 6,
        "options": [
            {
                "value": "InfoOutlined",
                "label": "InfoOutlined",
            },
        ],
    },
]

const AccordionWrapper = styled(MuiAccordion, {
    shouldForwardProp: (prop) => prop !== "variant",
})(({theme, variant}) => (theme.ACCORDION?.[variant]?.wrapper))

const AccordionTitle = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "variant",
})(({theme, variant}) => (theme.ACCORDION?.[variant]?.title))

const AccordionSubTitle = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "variant",
})(({theme, variant}) => (theme.ACCORDION?.[variant]?.subtitle))

const ContainerAccordion = ({container}) => {
    const [localOpen, setLocalOpen] = useState(container?.initialyOpen ?? false)
    const {getDataFromPointer, updateData} = useContext(DataContext)
    const pointer = getMerkmal(container)?.pointer
    const open = pointer ? getDataFromPointer(pointer) : localOpen

    const toggleOpen = useCallback(() => {
        pointer ? updateData(!open, pointer) : setLocalOpen(prev => !prev)
    }, [setLocalOpen, updateData, open, pointer])
    return (
        <AccordionBase
            Wrapper={AccordionWrapper}
            Title={AccordionTitle}
            Subtitle={AccordionSubTitle}
            variant={container?.variant ?? "DEFAULT"}
            expanded={open}
            onChange={toggleOpen}
            disabled={container?.disabled ?? false}
            text={container?.text}
            subtext={container?.subtext}
            badge={container?.badge}>
            {container?.children?.map((child) =>
                checkVisibility(child, getDataFromPointer) && (
                    <Content key={child.id} child={child} />
                )
            )}
        </AccordionBase>
    )
}

export default ContainerAccordion
